// Gradient Builder - Preview Canvas Component
// Live preview of gradient using CSS rendering

import React from "react";
import { GradientConfig } from "../../../model/gradient";
import { gradientToCss } from "../../../utils/gradientToCss";
import { colors, effects } from "../../../design/tokens";

interface GradientPreviewCanvasProps {
  config: GradientConfig;
  className?: string;
}

export const GradientPreviewCanvas: React.FC<GradientPreviewCanvasProps> = ({
  config,
  className = "",
}) => {
  const cssGradient = gradientToCss(config);

  return (
    <div
      className={`w-full h-full ${effects.borderRadius.lg} border ${colors.border.primary} overflow-hidden ${className}`}
      style={{
        background: cssGradient,
      }}
    />
  );
};
